import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { SxProps } from '@mui/system';
import { TextField, Theme } from '@mui/material'
import React, { MouseEventHandler, useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import '../../../App.css';
import DialogueBox from '../../../components/dialogueBox';
import SKUSingleSelectAutocomplete from '../../../components/skuSingleSelectAutocomplete';
import { BASE_URL, INPUT_FORMS, INPUT_SUGGESTIONS, SKU_PERF, EXCLUSIONS, NEWLISTANDDELIST, QUARTERS, CATEGORIES, AVAILABLE_QUARTERS, STATUSES, SKU_PERF_BY_COUNTRY } from '../../../constant/apiEndpoints';
import APIService from '../../../services/APIService';
import SKUAutoSuggestInput from '../../../components/skuAutoSuggestInput';
import { IAPIReturn } from '../../../services/_interfaces';
import { ISKUNewListAndDelistByCountry } from '../../../reducer/SKUExclusion/_interfaces';

const style:SxProps<Theme> = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70vw',
    height: '94vh',
    bgcolor: 'background.paper',
    border: '2px solid FFFFFF',
    boxShadow: 24,
    borderRadius: '8px',
    p: '1.5vh 3vh',
};

type IProps = {
    previousClosedQuarter: string,
    handleIsFormModalOpen: (value: boolean) => void,
    isFormModalOpen: boolean,
    formId: string,
    postSubmitAndEditData: () => void,
    selectedIdToEdit?: number,
    selectedObjToEdit: ISKUNewListAndDelistByCountry|null
}


const EditItem: React.FC<IProps> = (props) => {

    const [quarterList, setQuarterList] = React.useState([]);
    const [countryList, setCountryList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [itemCategoryList, setItemCategoryList] = useState([]);
    const [banDescriptionList, setBanDescriptionList] = useState([]);
    const [banNumberList, setBanNumberList] = useState([]);
    const [availableQuarterList, setAvailableQuarterList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    const [selectedQuarters, setSelectedQuarters] = React.useState<any>(props.previousClosedQuarter);
    const [selectedCountryList, setSelectedCountryList] = useState<any>([]);
    const [selectedTypeList, setSelectedTypeList] = useState<any>([]);
    const [selectedItemCategoryList, setSelectedItemCategoryList] = useState<any>([]);
    const [selectedBanDescriptionList, setSelectedBanDescriptionList] = useState<any>([]);
    const [selectedBanNumberList, setSelectedBanNumberList] = useState<any>([]);
    const [selectedAvailableQuarterList, setSelectedAvailableQuarterList] = useState<any>([]);
    const [selectedCategoryList, setSelectedCategoryList] = useState<any>([]);

    const [isEdit, setIsEdit] = React.useState(false);
    const [openDialogueBox, setOpenDialogueBox] = React.useState(false);
    const [messageType, setMessageType] = React.useState("");
    const [message, setMessage] = React.useState("");

    const releventData = {
        "selectedQuarters": selectedQuarters,
        "selectedCountryList": selectedCountryList,
        "selectedTypeList": selectedTypeList,
        "selectedItemCategoryList": selectedItemCategoryList,
        "selectedBanDescriptionList": selectedBanDescriptionList,
        "selectedBanNumberList": selectedBanNumberList,
    }

    const handleDialogueBox = () => {
        setOpenDialogueBox(!openDialogueBox)
    }

    const showDialogueBox = (msgType:string, msg:string) => {
        setMessage(msg);
        setMessageType(msgType);
        handleDialogueBox();
    }

    const handleOnClose = (value: boolean) => {
        props.handleIsFormModalOpen(value)
    }

    const getPayloadData = () => {
        return {
            "year": Number(selectedQuarters.slice(0, 4)),
            "time_frame": selectedQuarters.slice(4, 6),
            "country": selectedCountryList,
            "type": selectedTypeList,
            "item_category": selectedItemCategoryList,
            "ban_description": selectedBanDescriptionList,
            "ban_number": selectedBanNumberList,
            "category": selectedCategoryList,
            "new_year": Number(selectedAvailableQuarterList.slice(0, 4)),
            "new_time_frame": selectedAvailableQuarterList.slice(4, 6),
            'form_id': props.formId
        }
    }

    const addNewData = async (e: React.FormEvent) => {
        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST
        let response : IAPIReturn = await new APIService().post(url, getPayloadData())
        if (response.error) {
            if (response.status === 400) {
                if (response.results.message.includes("Non Field Errors")) {

                    showDialogueBox("Validation Error", response.results.message.substring(' Non Field Errors : '.length))
                } else {
                    // showDialogueBox("Error", (response.results.message.split('\t')[0]).replace("null", "empty"))
                    showDialogueBox("Error", "All Fields Are Required To Submit!")
                }
            }
        } else {
            toast.success('New data added Successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000, });
            props.postSubmitAndEditData();
            handleOnClose(false);
        }
    }

    const editExistingData = async (e: React.FormEvent) => {
        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST + props.selectedIdToEdit + '/'
        let response : IAPIReturn = await new APIService().patch(url, getPayloadData())
        if (response.error) {
            if (response.status === 400) {
                if (response.results.message.includes("Non Field Errors")) {

                    showDialogueBox("Validation Error", response.results.message.substring(' Non Field Errors : '.length))
                } else {
                    showDialogueBox("Error", (response.results.message.split('\t')[0]).replace("null", "empty"))
                }
            }
        } else {
            toast.success('Data updated Successfully.', { position: 'top-center', className: 'toast-popup', duration: 1000, });
            props.postSubmitAndEditData();
            handleOnClose(false);
        }
    }

    const handleOnSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        toast.loading('Submitting, Please Wait!',
            {
                position: 'top-center',
                className: 'toast-popup',
                duration: 1000,
            });
        if (props.selectedIdToEdit !== 0) {
            editExistingData(e);
        } else {
            addNewData(e);
        }
    }

    //Support Function For Filter List
    const createStringFromObjectList = (objs:{value: string}[]) => {
        let newString = ""
        objs.forEach(element => {
            if (newString.length === 0) {
                newString = element.value
            } else {
                newString = newString + "," + element.value
            }
        });
        
        return encodeURIComponent(newString)
    }

    const getReleventFilters = (releventData: any, valueType: string|null
    ) => {
        let releventFilters = ""
        if (releventData !== null) {
            if (valueType !== "Business Unit") {
                if (releventData['selectedBusinessUnitList'].length !== 0) {
                    releventFilters = releventFilters + `&selected_business_unit=${createStringFromObjectList([{ "value": releventData['selectedBusinessUnitList'] }])}`
                }
            }
            if (valueType !== "Type") {
                if (releventData['selectedTypeList'].length !== 0) {
                    releventFilters = releventFilters + `&selected_type=${createStringFromObjectList([{ "value": releventData['selectedTypeList'] }])}`
                }
            }
            if (valueType !== "Item Category") {
                if (releventData['selectedItemCategoryList'].length !== 0) {
                    releventFilters = releventFilters + `&selected_item_category=${createStringFromObjectList([{ "value": releventData['selectedItemCategoryList'] }])}`
                }
            }
            if (valueType !== "Quarter") {
                if (releventData['selectedQuarters'].length !== 0) {
                    releventFilters = releventFilters + `&selected_quarter=${createStringFromObjectList([{ "value": releventData['selectedQuarters'] }])}`
                }
            }
            if (valueType !== "Ban Description") {
                if (releventData['selectedBanDescriptionList'].length !== 0) {
                    releventFilters = releventFilters + `&selected_ban_description=${createStringFromObjectList([{ "value": releventData['selectedBanDescriptionList'] }])}`
                }
            }
            if (valueType !== "Ban Number") {
                if (releventData['selectedBanNumberList'].length !== 0) {
                    releventFilters = releventFilters + `&selected_ban_number=${createStringFromObjectList([{ "value": releventData['selectedBanNumberList'] }])}`
                }
            }
        }
        return releventFilters
    }

    const loadReleventData = (objs: any) => {
        toast.loading('Loading, Please Wait!',
            {
                position: 'top-center',
                className: 'toast-popup',
                duration: 2000,
            });

            loadBusinessUnitList(objs);
            loadItemCategoryList(objs);
            loadQuarterList(objs);
            loadBanDescriptionList(objs);
            loadBanNumberList(objs);

    }

    const setReleventDropDownValues = (objs: any, valueType: string) => {
        var newObj = releventData

        if (valueType === "Country") {
            setSelectedCountryList(objs)
            newObj['selectedCountryList'] = objs
        }
        else if (valueType === "Type") {
            setSelectedTypeList(objs)
            newObj['selectedTypeList'] = objs
        }
        else if (valueType === "Item Category") {
            debugger;
            setSelectedItemCategoryList(objs)
            newObj['selectedItemCategoryList'] = objs
        }
        else if (valueType === "Quarter") {
            setSelectedQuarters(objs)
            newObj['selectedQuarters'] = objs
        }
        else if (valueType === "Ban Description") {
            setSelectedBanDescriptionList(objs)
            newObj['selectedBanDescriptionList'] = objs
        }
        else if (valueType === "Ban Number") {
            setSelectedBanNumberList(objs)
            newObj['selectedBanNumberList'] = objs
        }
        
        loadReleventData(newObj);
    }

    const setDropDownValues = (objs: any, valueType: string) => {
        if (valueType === "Category") {
            setSelectedCategoryList(objs)
        }
        else if (valueType === "Available Quarter") {
            setSelectedAvailableQuarterList(objs)
        }
    }

    const loadQuarterList = async (releventData = null, valueType: string| null =null) => {
        const releventFilters = getReleventFilters(releventData, valueType);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST + INPUT_SUGGESTIONS + QUARTERS + `?selected_form=${props.formId}` + releventFilters
        let response :  IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            const transformedData = response.results.map(({ label, value }:{label: string, value: string}) => ({ id: value, title: label }));
            setQuarterList(transformedData);
        }
    }

    const loadBusinessUnitList = async (releventData = null, valueType = null) => {
        const releventFilters = getReleventFilters(releventData, valueType);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST + INPUT_SUGGESTIONS + `?selected_form=${props.formId}&filter_type=country__name` + releventFilters
        
        let response : IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            debugger;
            setCountryList(response.results);
        }
    }

    //AJAX Call To Load Category SAP List
    const loadTypeList = async (releventData = null, valueType = null) => {
        const releventFilters = getReleventFilters(releventData, valueType);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + STATUSES + `?selected_form=${props.formId}`
        let response : IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            setTypeList(response.results);
        }
    }
    const loadItemCategoryList = async (releventData = null, valueType = null) => {
        debugger;
        const releventFilters = getReleventFilters(releventData, valueType);
        debugger;
        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST + INPUT_SUGGESTIONS + `?selected_form=${props.formId}&filter_type=skuexclusionmaterialbycountry__item_category` + releventFilters
        let response : IAPIReturn = await new APIService().get(url);
        debugger;
        if (response.error) {
            console.log("error in Brand Category Mapping List API", response.results.message)
        } else {
            debugger;
            if (response.results.length === 1){
                setSelectedItemCategoryList(response.results[0].id)
            }
            setItemCategoryList(response.results);
        }
    }

    const loadBanDescriptionList = async (releventData = null, valueType = null) => {
        const releventFilters = getReleventFilters(releventData, valueType);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST + INPUT_SUGGESTIONS + `?selected_form=${props.formId}&filter_type=ban_description` + releventFilters
        let response : IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand Category Mapping List API", response.results.message)
        } else {
            setBanDescriptionList(response.results);
        }
    }

    const loadBanNumberList = async (releventData = null, valueType = null) => {
        const releventFilters = getReleventFilters(releventData, valueType);

        let url = BASE_URL + INPUT_FORMS + SKU_PERF_BY_COUNTRY + EXCLUSIONS + NEWLISTANDDELIST + INPUT_SUGGESTIONS + `?selected_form=${props.formId}&filter_type=ban_number` + releventFilters
        let response : IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand Category Mapping List API", response.results.message)
        } else {
            setBanNumberList(response.results);
        }
    }

    const loadAvailableQuarterList = async () => {
        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + INPUT_SUGGESTIONS + AVAILABLE_QUARTERS + `?selected_form=${props.formId}`
        let response : IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            setAvailableQuarterList(response.results);
        }
    }

    const loadCategoryList = async () => {
        let url = BASE_URL + INPUT_FORMS + SKU_PERF + EXCLUSIONS + NEWLISTANDDELIST + CATEGORIES + `?selected_form=${props.formId}`
        let response : IAPIReturn = await new APIService().get(url);
        if (response.error) {
            console.log("error in Brand List API", response.results.message)
        } else {
            setCategoryList(response.results);
        }
    }

    const loadSuggestionData = () => {
        loadBanDescriptionList();
        loadBanNumberList();
        loadQuarterList();
        loadBusinessUnitList();
        loadTypeList();
        loadItemCategoryList();
        loadCategoryList();
        loadAvailableQuarterList();
    }

    //useEffect Method
    useEffect(() => {
        let mounted = true
        if (mounted) {
            if (props.selectedIdToEdit !== undefined  && props.selectedObjToEdit !== null) {
                setSelectedQuarters(props.selectedObjToEdit.quarter_id)
                setSelectedCountryList(props.selectedObjToEdit.country_name)
                setSelectedTypeList(props.selectedObjToEdit.type_title)
                setSelectedItemCategoryList(props.selectedObjToEdit.item_category)
                setSelectedBanDescriptionList(props.selectedObjToEdit.ban_description)
                setSelectedBanNumberList(props.selectedObjToEdit.ban_number)
                setSelectedAvailableQuarterList(props.selectedObjToEdit.new_quarter_id)
                setSelectedCategoryList(props.selectedObjToEdit.category_title)
                setIsEdit(true);
            }
            toast.loading('Loading, Please Wait!',
                {
                    position: 'top-center',
                    className: 'toast-popup',
                    duration: 2000,
                });
            loadSuggestionData();
        }
        return function cleanup() {
            mounted = false
        }
    }, []);

    return (
        <div>
            <Modal
                open={props.isFormModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className="brand-category-modal-form-header">
                        {isEdit ?
                            <p>ID : {props.selectedIdToEdit}</p>
                            : <p>Add New Entry</p>}
                        <div className="brand-category-modal-form-close-button" onClick={() => handleOnClose(false)}>
                            X
                        </div>
                    </div>
                    <div className="brand-category-modal-form-body">
                        <div className="brand-category-modal-form-input-container row m-0">
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Quarter</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedQuarters.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title="Quarter" dataList={quarterList}
                                        currentValue={selectedQuarters}
                                        autoSuggestOnChange={setReleventDropDownValues} 
                                        isNonEditableField={true} />}
                                {!isEdit &&
                                    <TextField inputProps={{ style: { height: '9px' } }} className='m-qrtr' disabled value={props.previousClosedQuarter}/>
                                }
                            </div>
                            
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>{props.formId === 'formskuByCountry' ? "Country" : "Business Unit"}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedCountryList.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title={props.formId === 'formskuByCountry' ? "Country" : "Business Unit"} dataList={countryList}
                                        currentValue={selectedCountryList}
                                        autoSuggestOnChange={setReleventDropDownValues} 
                                        isNonEditableField={true} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title={props.formId === 'formskuByCountry' ? "Country" : "Business Unit"} options={countryList}
                                        setParentDropdownValue={setReleventDropDownValues} />}

                            </div>
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Type(Newlist/Delist)</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedTypeList.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title="Type" dataList={typeList}
                                        currentValue={selectedTypeList}
                                        autoSuggestOnChange={setReleventDropDownValues} 
                                        isNonEditableField={true} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title="Type" options={typeList}
                                        setParentDropdownValue={setReleventDropDownValues} />}
                            </div>
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Item Category</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedItemCategoryList.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title="Item Category" dataList={itemCategoryList}
                                        currentValue={selectedItemCategoryList}
                                        autoSuggestOnChange={setReleventDropDownValues} 
                                        isNonEditableField={true} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title="Item Category" options={itemCategoryList}
                                        setParentDropdownValue={setReleventDropDownValues} />}
                            </div>
                        </div>
                        <div className="brand-category-modal-form-input-container row m-0">

                            <div className="brand-category-modal-form-input col-2"></div>
                        </div>

                        <div className="brand-category-modal-form-input-container row m-0">
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Ban Description</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedBanDescriptionList.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title="Ban Description" dataList={banDescriptionList}
                                        currentValue={selectedBanDescriptionList}
                                        autoSuggestOnChange={setReleventDropDownValues} 
                                        isNonEditableField={true} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title="Ban Description" options={banDescriptionList}
                                        setParentDropdownValue={setReleventDropDownValues} />}
                            </div>
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Ban Number</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedBanNumberList.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title="Ban Number" dataList={banNumberList}
                                        currentValue={selectedBanNumberList}
                                        autoSuggestOnChange={setReleventDropDownValues} 
                                        isNonEditableField={true} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title="Ban Number" options={banNumberList}
                                        setParentDropdownValue={setReleventDropDownValues} />}
                            </div>
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Category</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedCategoryList.length > 0 && isEdit &&
                                    <SKUAutoSuggestInput title="Category" dataList={categoryList}
                                        currentValue={selectedCategoryList}
                                        autoSuggestOnChange={setDropDownValues}
                                        isNonEditableField={false} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title="Category" options={categoryList}
                                        setParentDropdownValue={setDropDownValues} />}
                            </div>
                            <div className="brand-category-modal-form-input col-3 p-0">
                                <div style={{ display: "flex" }}>
                                    <p>Quarter(Newlist/Delist)</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {selectedAvailableQuarterList.length > 0 && isEdit &&
                                <SKUAutoSuggestInput title="Available Quarter" dataList={availableQuarterList}
                                currentValue={selectedAvailableQuarterList}
                                autoSuggestOnChange={setDropDownValues}
                                isNonEditableField={false} />}
                                {!isEdit &&
                                    <SKUSingleSelectAutocomplete title="Available Quarter" options={availableQuarterList}
                                        setParentDropdownValue={setDropDownValues} />}
                            </div>
                        </div>
                    </div>
                    <div className="brand-category-modal-form-footer row m-0">
                        <div className="brand-category-modal-form-input col-6">
                        </div>
                        <div className="brand-category-modal-form-input col-6">
                            <div style={{ float: "right" }}>
                                <button className="brand-category-form-modal-cancel-button mt-3" onClick={() => handleOnClose(false)}>Cancel</button>
                                <button className="brand-category-form-modal-submit-button mt-3" onClick={handleOnSubmit}>Submit</button>
                            </div>
                        </div>

                    </div>
                </Box>
            </Modal>
            {/* Message Dialogue Box */}
            {openDialogueBox ? <DialogueBox openDialogueBox={openDialogueBox}
                handleDialogueBox={handleDialogueBox}
                messageType={messageType}
                message={message} /> : ""}
            {/* Message Dialogue Box */}
            {/* Loader */}
            <Toaster />
            {/* Loader */}
        </div>
    )
};

export default EditItem;
